
  // Export
  module.exports =
  {

    // Password scripts
    reset:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Get the password script
        $.getScript(APPLICATION._PATH_PREFIX + 'includes/js/password.js?v=' + APPLICATION._PASSWORD_VERSION, function ()
        {

          // On generating the password
          $('#generate_password').not('.js-ignore').click(function ()
          {

            // Generate the password
            PasswordGenerator.generate(function (password)
            {
          
              // Show the generated password
              $('#generated_password').val(password)
          
              // Enter the password
              $('#password').val(password)

            }
            )

          }
          ).addClass('js-ignore')

        }
        )

        // On clicking the generated password
        $('#generated_password').not('.js-ignore').click(function ()
        {
          this.select()
        }
        ).addClass('js-ignore')
     
      }

    }

  }